import * as React from 'react';
import * as style from './style.css';
import { UIText1, UIText2 } from '@cian/ui-kit';
import { OffersRow } from '../OffersRow';
import { Link } from '../Link';
import { TrackingContext, OffersContext } from '../../../../shared/context';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HEADER_ITEMS = ['Площадь', 'Срок сдачи', 'Этаж', 'Стоимость', ''];
export const OffersTable = () => {
  const {
    layout
  } = React.useContext(OffersContext);
  const {
    trackModalListingLinkClick,
    trackModalOfferLinkClick
  } = React.useContext(TrackingContext);
  return /*#__PURE__*/_jsxs("div", {
    className: style['container'],
    children: [/*#__PURE__*/_jsxs("div", {
      className: style['table-header'],
      children: [HEADER_ITEMS.map((item, index) => /*#__PURE__*/_jsx("div", {
        className: style['header-cell'],
        children: /*#__PURE__*/_jsx(UIText2, {
          color: "current_color",
          textAlign: index === 3 ? 'right' : 'left',
          children: item
        })
      }, index)), /*#__PURE__*/_jsx("div", {
        className: style['divider']
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: style['table'],
      children: [layout.offers.map(offer => /*#__PURE__*/_jsx(OffersRow, {
        offer: offer,
        onOfferLinkClick: trackModalOfferLinkClick
      }, offer.id)), /*#__PURE__*/_jsx("div", {
        className: style['offers-link-block'],
        children: /*#__PURE__*/_jsx(UIText1, {
          children: /*#__PURE__*/_jsx(Link, {
            href: layout.offersLink,
            target: "_blank",
            onClick: trackModalListingLinkClick,
            children: layout.offersTitle
          })
        })
      })]
    })]
  });
};